import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import SingleFeaturedProject from "./SingleFeaturedProject"
import { BsArrowRight } from "react-icons/bs"
import { Link } from "gatsby"

const FeaturedProjects = () => {
  const data = useStaticQuery(graphql`
    {
      featuredprojects: allContentfulMyProjects(
        filter: { featured: { eq: true } }
      ) {
        edges {
          node {
            id
            title
            techStack
            description {
              description
            }
            github
            liveDemo
            image {
              fluid(maxWidth: 800, quality: 100) {
                src
                ...GatsbyContentfulFluid
              }
            }
          }
        }
      }
    }
  `)
  return (
    <section className="bg-dark pt-0 pb-5 md:pt-10 md:pb-16 lg:pt-20 lg:pb-16">
      <div className="max-w-screen-md lg:max-w-screen-lg lg:mx-16 xl:mx-auto mx-auto">
        <div className="bg-secondary h-auto mx-2 md:mx-10 lg:mx-0 rounded-lg px-6 py-12 md:px-10 lg:pb-16">
          <div className="md:px-10 lg:pt-5 pb-3 md:pb-0">
            <h1 className="text-sm uppercase md:text-base lg:text-xl text-yellow-500 font-metropolis font-hairline tracking-wide">
              Experience
            </h1>
            <h2 className="text-white text-xl md:text-2xl lg:text-4xl font-metropolis font-normal tracking-normal">
              Latest Projects
            </h2>
          </div>
          <div className="grid grid-cols-1 divide-solid divide-y-4 divide-black divide-opacity-25">
            {data.featuredprojects.edges.map(({ node: project }) => {
              return (
                <SingleFeaturedProject key={project.id} project={project} />
              )
            })}
          </div>
          <div className="flex justify-center mt-10 md:mt-12 xl:mt-16">
            <Link to="/projects" target="_blank">
              <button className="flex w-full items-center justify-center bg-yellow-500 py-3 px-10 md:px-20 lg:px-32 font-metropolis font-medium  hover:bg-white transition-all duration-500 ease-linear text-sm focus:outline-none text-black">
                VIEW ALL PROJECTS
                <div className="pl-4 md:pl-4">
                  <BsArrowRight className="text-black text-xl" />
                </div>
              </button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  )
}

export default FeaturedProjects
